// This mixin contains code that is used for only electricity non half hourly readings
import readings from "./readings";

export default {
  mixins: [readings],
  computed: {
    summaryFields() {
      return {
        ReadingDate: { label: "Date", sortable: true, class: "text-center" },
        MeterSerial: { label: "Meter Serial", class: "text-center" },
        ...this.registerReadingHeaders,
        ReadingType: { label: "Reading Type", class: "text-center" },
        ValidationStatus: { label: "Validation", class: "text-center" },
        AssociatedInvoices: { label: "Billing", class: "text-center" },
       // ReadingEvent: { label: "", class: "text-center" },
      };
    },
    meterConfigs() {
      let meterConfigs = [];
      this.meters
        .filter((meter) => meter.Serial === this.meterSerialFilter)
        .forEach((meter) => {
          meterConfigs = this.$_.union(meterConfigs, meter.MeterConfigs);
        });
      return meterConfigs;
    },

    registers() {
      const order = { Unrestricted: 0, Day: 1, Night: 2, EveWeekend: 3 };

      return this.meterConfigs
        .flatMap((config) =>
          config.Registers.map((register) => ({
            ...register,
            MeterConfigSharedId: config.SharedId,
          }))
        )
        .filter((r) => r.IsSettlement && r.BillingTypeId !== "NotApplicable")
        .sort((a, b) => order[a.BillingTypeId] - order[b.BillingTypeId]);
    },

    registerReadingHeaders() {
      let headers = {};

      this.registers.forEach((register) => {
        headers[
          `${register.RegisterId}:${register.BillingTypeId}:${register.Tpr}`
        ] = {
          label: `${register.RegisterId} - ${register.BillingTypeId} (${
            register.Tpr
          })`,
          class: "text-center",
        };
      });

      return headers;
    },

    mappedReadings() {
      return this.filteredReadings.map((reading) => {
        const config = this.meterConfigs.find(
          (config) => config.SharedId === reading.MeterConfigSharedId
        );

        if (config) {
          return {
            ...reading,
            RegisterReadings: reading.RegisterReadings.map((rr) => {
              const register = config.Registers.find(
                (r) => r.RegisterId === rr.MeterRegisterId
              );
              if (register) {
                return {
                  ...rr,
                  BillingTypeId: register.BillingTypeId,
                  Tpr: register.Tpr,
                };
              } else {
                return;
              }
            }),
          };
        } else {
          return;
        }
      });
    },
  },
  methods: {
    padReading(reading, configSharedId, registerId) {
      let maxDigits = this.getRegister(configSharedId, registerId).Digits;
      // let parsedReading = reading.toString().split('.')[0]
      let parsedReading = ~~reading;
      return parsedReading.toString().padStart(maxDigits, "0");
    },
    getRegister(meterConfigSharedId, registerId) {
      // Looks for register with matching RegisterId in meter config with matching SharedID
      return this.$_.findWhere(
        this.$_.findWhere(this.meterConfigs, {
          SharedId: meterConfigSharedId,
        }).Registers,
        {
          RegisterId: registerId,
        }
      );
    },
    getBillingType(meterConfigSharedId, registerId) {
      let register = this.getRegister(meterConfigSharedId, registerId);
      return register ? register.BillingTypeId : "n/a";
    },
    isBillable(event, item) {
      this.$http
        .put(
          "https://" +
            this.$config.honeycomb.readingsbot.electricity.domain +
            "/api/v1/readings/" +
            item.Id,
          {
            Id: item.Id,
            DoNotBill: !item.DoNotBill,
          },
          {
            withCredentials: true,
          }
        )
        .then(() => {
          this.$store.dispatch("refreshReadings");
        });
    },

    sortReadings(readings, meterConfigSharedId) {
      const order = {
        Unrestricted: 0,
        Day: 1,
        Night: 2,
        EveWeekend: 3,
      };

      return [...readings].sort(
        (a, b) =>
          order[this.getBillingType(meterConfigSharedId, a.MeterRegisterId)] -
          order[this.getBillingType(meterConfigSharedId, b.MeterRegisterId)]
      );
    },
  },

  filters: {
    validationStatus(status) {
      switch (status) {
        case "Failed":
          return "F";
        case "NotValidated":
          return "U";
        case "Valid":
          return "V";
        default:
          return "";
      }
    },
  },
};
